import { Button, Dialog, DialogTitle, Grid2, Typography } from '@mui/material'
import { Dispatch, memo, ReactNode, SetStateAction } from 'react'
import { useApp } from '../contexts/AppContext'

const ConfirmDialog = memo(({ children, title, text, component, onConfirm, open, setOpen }: { children: ReactNode, title: string, text: string, component?: ReactNode, onConfirm: VoidFunction, open: boolean, setOpen: Dispatch<SetStateAction<boolean>> }) => {
    const {translate} = useApp()

    return (
        <>
            {children}
            <Dialog open={open}>
                <DialogTitle>{title}</DialogTitle>
                <Grid2 container flexDirection={'column'} padding={2} spacing={2}>
                    {component &&
                        <Grid2>
                            {component}
                        </Grid2>
                    }
                    <Grid2>
                        <Typography>{text}</Typography>
                    </Grid2>
                    <Grid2 container spacing={2} justifyContent={'end'}>
                        <Grid2>
                            <Button onClick={() => setOpen(false)} variant='outlined'>{translate("Cancel")}</Button>
                        </Grid2>
                        <Grid2>
                            <Button onClick={onConfirm} variant='contained'>{translate("Yes")}</Button>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Dialog>
        </>
    )
})

export default ConfirmDialog